import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=06b02aa0&scoped=true&lang=pug&"
import script from "./Example.vue?vue&type=script&lang=js&"
export * from "./Example.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b02aa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/happy.tsugawa-banta/Documents/projects/dashing-diva/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b02aa0')) {
      api.createRecord('06b02aa0', component.options)
    } else {
      api.reload('06b02aa0', component.options)
    }
    module.hot.accept("./Example.vue?vue&type=template&id=06b02aa0&scoped=true&lang=pug&", function () {
      api.rerender('06b02aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Example.vue"
export default component.exports